import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { applyFontSize, readFontSize, writeFontSize, type FontSize } from '@/ui/theme/fontSize'

const SIZES: FontSize[] = ['sm', 'md', 'lg']

/**
 * Three-button segmented switcher (S / M / L) for the markdown
 * reading-area font size. Persists in localStorage; mirrors to the
 * `data-font-size` attribute on `<html>` so theme.css picks it up.
 */
export function FontSizeSwitcher() {
  const { t } = useTranslation()
  const [current, setCurrent] = useState<FontSize>(() => readFontSize())

  useEffect(() => {
    applyFontSize(current)
  }, [current])

  function pick(next: FontSize) {
    setCurrent(next)
    writeFontSize(next)
  }

  return (
    <div
      role="radiogroup"
      aria-label={t('fontSize.label')}
      className="markfy-fontsize-switcher"
    >
      {SIZES.map((size) => (
        <button
          key={size}
          type="button"
          role="radio"
          aria-checked={current === size}
          onClick={() => pick(size)}
          className="markfy-fontsize-option"
          data-active={current === size}
          title={t(`fontSize.${size}`)}
        >
          {t(`fontSize.${size}`)}
        </button>
      ))}
    </div>
  )
}
